/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadAdmissionFlagsInnerAdmissionFlagAliasesInner
 */
export interface LeadAdmissionFlagsInnerAdmissionFlagAliasesInner {
    /**
     * 
     */
    value?: string;
}

/**
 * Check if a given object implements the LeadAdmissionFlagsInnerAdmissionFlagAliasesInner interface.
 */
export function instanceOfLeadAdmissionFlagsInnerAdmissionFlagAliasesInner(value: object): value is LeadAdmissionFlagsInnerAdmissionFlagAliasesInner {
    return true;
}

export function LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerFromJSON(json: any): LeadAdmissionFlagsInnerAdmissionFlagAliasesInner {
    return LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerFromJSONTyped(json, false);
}

export function LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadAdmissionFlagsInnerAdmissionFlagAliasesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerToJSON(json: any): LeadAdmissionFlagsInnerAdmissionFlagAliasesInner {
    return LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerToJSONTyped(json, false);
}

export function LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerToJSONTyped(value?: LeadAdmissionFlagsInnerAdmissionFlagAliasesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
    };
}

